// remove null from interface
export type Filled<T> = { [P in keyof T]: NonNullable<T[P]>; };

export const enum LoadingStatus {
    Idle = 'idle',
    Loading = 'loading',
    Loaded = 'loaded',
    Error = 'error'
}

export interface Entity<Id = number> { 
    id: Id,
}

export interface LabeledValue<Value = string> {
    label: string,
    value: Value,
}

export interface Consultation extends Entity<string> {
    title: string,
    status: string,
    statusTitle: string,
    price: number,
    address?: string,
}

export interface Doctor extends Entity {
    fullName: string,
    experience: number,
    specialization: string,
}

export interface Patient extends Entity {
    fullName: string,
    email: string,
    phone: string,
    birthDate?: string,
    city?: string,
}

export interface Clinic extends Entity {
    title: string,
    phone: string,
    address: string,
}

export interface City extends Entity {
    name: string,
    timezone: string,
}

export interface FileEntity extends Entity {
    src: string,
    file?: File,
}

export type Photo = FileEntity;

export interface MedicalService extends Entity {
    title: string,
}

export interface Specialization extends Entity {
    title: string,
    type?: string,
}

export type Maybe<Type, NoValue = null> = Type | NoValue;

export type Errors<Key extends string | number = string, Value = string> = Record<Key, Value>
export type Numeric = number | '';
